class SocialProof {
  constructor() {
    this.sections = document.querySelectorAll('.social-proof');
    this.init();
  }

  init() {
    if (!this.sections.length) return;
    
    this.sections.forEach(section => {
      this.initSwiper(section);
    });
  }

  initSwiper(section) {
    const swiperElement = section.querySelector('.social-proof__swiper');
    if (!swiperElement) return;

    const actualSlides = swiperElement.querySelectorAll('.swiper-slide').length;
    
    if (actualSlides === 0) return;


    const swiperConfig = {
      slidesPerView: 'auto',
      spaceBetween: 16,
      loop: actualSlides > 3,
      grabCursor: true,      
      centeredSlides: false,
      
      on: {
        init: function() {
          this.slides.forEach(slide => {
            const img = slide.querySelector('img[loading="lazy"]');
            if (img && !img.src) {
              img.src = img.dataset.src;
            }
          });
        },
        slideChange: function() {
          this.slides.forEach((slide, index) => {
            const video = slide.querySelector('.social-proof__video-element');
            if (video) {
              if (index === this.activeIndex) {
                if (video.hasAttribute('autoplay')) {
                  video.play().catch(() => {});
                }
              } else {
                video.pause();
              }
            }
          });
        }
      }
    };


    const swiper = new Swiper(swiperElement, swiperConfig);

    section.swiperInstance = swiper;

    this.handleVideoClicks(section);
    
    this.handleAccessibility(section);
  }

  handleVideoClicks(section) {
    const videos = section.querySelectorAll('.social-proof__video-element');
    
    videos.forEach(video => {
      video.addEventListener('click', (e) => {
        if (video.paused) {
          video.play().catch(() => {});
        } else {
          video.pause();
        }
      });
    });
  }

  handleAccessibility(section) {
    const slides = section.querySelectorAll('.social-proof__slide');
    slides.forEach((slide, index) => {
      slide.setAttribute('aria-label', `Slide ${index + 1}`);
    });

    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      if (section.swiperInstance) {
        section.swiperInstance.params.speed = 0;
      }
    }
  }

  destroy() {
    this.sections.forEach(section => {
      if (section.swiperInstance) {
        section.swiperInstance.destroy(true, true);
      }
    });
  }

  update() {
    this.sections.forEach(section => {
      if (section.swiperInstance) {
        section.swiperInstance.update();
      }
    });
  }
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => {
    window.socialProof = new SocialProof();
  });
} else {
  window.socialProof = new SocialProof();
}

document.addEventListener('shopify:section:load', (event) => {
  if (event.target.querySelector('.social-proof')) {
    if (window.socialProof) {
      window.socialProof.destroy();
    }
    window.socialProof = new SocialProof();
  }
});

document.addEventListener('shopify:section:unload', (event) => {
  if (event.target.querySelector('.social-proof')) {
    const section = event.target.querySelector('.social-proof');
    if (section.swiperInstance) {
      section.swiperInstance.destroy(true, true);
    }
  }
});

let resizeTimer;
window.addEventListener('resize', () => {
  clearTimeout(resizeTimer);
  resizeTimer = setTimeout(() => {
    if (window.socialProof) {
      window.socialProof.update();
    }
  }, 250);
});
